import React from "react";
import { useTranslation } from "react-i18next";
import { MoneyApi } from "go-core/api/types";
import { getFormattedItemCost } from "go-core/utils/utils";

interface CostModifiersListProps {
	discountPrice?: MoneyApi;
	tip?: MoneyApi;
	subTotalPrice: MoneyApi;
}

export const CostModifiersList = ({ discountPrice, tip, subTotalPrice }: CostModifiersListProps): JSX.Element => {
	const { t } = useTranslation();

	if ((!discountPrice || discountPrice?.amount === 0) && (!tip || tip?.amount === 0)) return <></>;

	return (
		<section data-testid="e-order-order-details-cost-modifiers-list">
			<ul>
				<li data-testid="e-order-order-details-cost-modifiers-list-sub-total-price">
					<span className="text-muted">{`${t("modules.e_order.field.sub_total_price.title")}:`}</span>
					<span>{getFormattedItemCost(subTotalPrice.amount, subTotalPrice.currency)}</span>
				</li>
				{discountPrice && discountPrice.amount > 0 && (
					<li data-testid="e-order-order-details-cost-modifiers-list-discount-price">
						<span className="text-muted">{`${t("modules.e_order.field.discount.title")}:`}</span>
						<span>-{getFormattedItemCost(discountPrice.amount, discountPrice.currency)}</span>
					</li>
				)}
				{tip && tip.amount > 0 && (
					<li data-testid="e-order-order-details-cost-modifiers-list-tip">
						<span className="text-muted">{`${t("modules.e_order.field.tip.title")}:`}</span>
						<span>{getFormattedItemCost(tip.amount, tip.currency)}</span>
					</li>
				)}
			</ul>
		</section>
	);
};
